module.exports = __webpack_public_path__ + "img/home_ys_s_icon.906d969.png";